export default __webpack_public_path__ + "static/media/light_dark_light.92831f59.svg";